import makeStyles from "@material-ui/core/styles/makeStyles";
import Typography from "@material-ui/core/Typography";
import logo from "assets/logos/logo-prendo-by-mg-group.svg";

const useStyles = makeStyles((theme) => ({
  container: {
    width: "100vw",
    height: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#f9f7fc",
  },
  content: {
    textAlign: "center",
    maxWidth: 500,
    padding: 20,
  },
  logo: {
    width: 200,
    marginBottom: 40,
  },
  title: {
    color: theme.palette.primary.main,
    fontWeight: 700,
    fontSize: 21,
    marginBottom: 16,
  },
  description: {
    fontSize: 16,
    color: "#757575",
    lineHeight: 1.5,
  },
}));

const Maintenance = () => {
  const classes = useStyles();

  return (
    <div className={classes.container}>
      <div className={classes.content}>
        <img src={logo} alt="MG Marketplace" className={classes.logo} />
        <Typography className={classes.title}>
          Mantenimiento en curso
        </Typography>
        <Typography className={classes.description}>
          Estamos realizando mejoras en nuestra app.
          <br />
          Por favor, volvé a intentarlo más tarde.
        </Typography>
      </div>
    </div>
  );
};

export default Maintenance;
